<template>
  <FriedModal :size="ModalSize.Large" class="participants-overview-modal" @close="$emit('close')">
    <template #header>
      <FriedModalHeader :header="t('dsr_room_participants')" />
    </template>
    <FriedParagraph>
      {{ t('dsr_the_following_list_all_participants') }}
    </FriedParagraph>
    <div class="participants-list">
      <FriedH5 class="invited-participants-text"
        >{{ t('dsr_invited_people') }} {{ `(${participants.length})` }}</FriedH5
      >
      <div class="scroll-container">
        <div
          v-for="participant in participants"
          :key="participant.email"
          class="participant-container"
        >
          <ParticipantItem :participant="participant" />
        </div>
      </div>
    </div>
  </FriedModal>
</template>

<script lang="ts">
import type { PropType } from 'vue';
import { defineComponent } from 'vue';
import { ModalSize } from '@getaccept/fried-tofu';
import { useI18n } from 'vue-i18n';
import ParticipantItem from '@getaccept/dsr-shared-new/src/components/ParticipantItem.vue';
import type { Participant } from '@getaccept/dsr-shared-new';

export default defineComponent({
  components: {
    ParticipantItem,
  },
  props: {
    participants: {
      type: Array as PropType<Participant[]>,
      default: () => [],
    },
  },
  setup() {
    const { t } = useI18n();
    return {
      ModalSize,
      t,
    };
  },
});
</script>
<style lang="scss" scoped>
.participants-overview-modal {
  display: flex;
  align-items: center;
}

.participants-list {
  display: flex;
  flex-direction: column;
  overflow: auto;
  background: var(--gray-99);
  border-radius: $border-radius-md-lg;
  padding: var(--spacing-100);
  margin-top: var(--spacing-100);

  @media screen and (max-width: $sm) {
    background: none;
    padding: 0;
  }

  .invited-participants-text {
    color: var(--text-gray);
    margin-bottom: var(--spacing-100);
  }

  .scroll-container {
    height: 324px;
    overflow: auto;
  }

  .participant-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    &:not(:last-child) {
      margin-bottom: var(--spacing-50);
    }
  }
}
</style>
